"use client";

import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
const accounts = [{
  id: "standard",
  title: "ISO 14001",
  subtitle: "Ambiental",
  desc: "Certificación internacional que avala nuestro sistema de gestión ambiental y el compromiso con la reducción del impacto ecológico en cada proceso.",
  bgText: "ISO"
}, {
  id: "raw",
  title: "Industria Limpia",
  subtitle: "Nacional",
  desc: "Reconocimiento otorgado por la PROFEPA por cumplir con la normatividad ambiental vigente y operar bajo estándares de eficiencia energética.",
  bgText: "PRO"
}, {
  id: "elite",
  title: "ESR 2024",
  subtitle: "Social",
  desc: "Distintivo de Empresa Socialmente Responsable que reconoce nuestra ética empresarial y el impacto positivo en la comunidad y colaboradores.",
  bgText: "ESR"
}, {
  id: "ctrader",
  title: "EcoVadis",
  subtitle: "Global",
  desc: "Calificación de sostenibilidad empresarial que evalúa nuestro desempeño en medio ambiente, prácticas laborales y compras sostenibles.",
  bgText: "ECO"
}];
export default function CertificationsRecognition() {
  const [activeIndex, setActiveIndex] = useState(0);
  return <section data-section-id="252231" id="certifications-recognition" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col md:flex-row gap-4 h-auto md:h-[500px] w-full">
          {accounts.map((acc, i) => {
          const isActive = activeIndex === i;
          return <div key={acc.id} data-index={i} onClick={() => setActiveIndex(i)} className={`relative overflow-hidden rounded-lg transition-all duration-500 ease-in-out cursor-pointer flex-shrink-0 group ${isActive ? "md:flex-grow md:w-auto w-full bg-primary-100/50" : "md:w-[120px] w-full bg-muted hover:bg-primary-100/30"}`}>
                {isActive ? <div className="flex flex-col items-center justify-center h-full p-8 md:p-12 text-center animate-in fade-in duration-700">
                    {}
                    <div className="absolute inset-0 overflow-hidden pointer-events-none flex items-end justify-center pb-4 md:pb-10">
                      <span className="text-[8rem] md:text-[16rem] font-bold leading-none text-transparent [-webkit-text-stroke:1px_hsl(var(--primary)/0.15)] select-none">
                        {acc.bgText}
                      </span>
                    </div>

                    {}
                    <div className="relative z-10 flex flex-col items-center">
                      <h3 className="text-4xl md:text-5xl font-bold font-default text-primary">
                        {acc.title}
                      </h3>
                      <span className="text-lg md:text-xl font-semibold text-accent mt-1">
                        {acc.subtitle}
                      </span>
                      <p className="mt-6 text-muted-foreground max-w-md text-sm md:text-base leading-relaxed font-default">
                        {acc.desc}
                      </p>
                      <Button size="lg" className="mt-8 rounded-md px-8 py-6 text-base font-semibold bg-primary text-primary-foreground hover:bg-primary-600 shadow-md">
                        Ver Certificado
                      </Button>
                    </div>
                  </div> : <div className="flex md:flex-col flex-row items-center justify-between h-full p-6 md:py-8 w-full">
                    {}
                    <div className="flex-1 flex items-center md:justify-center justify-start relative w-full">
                      <div className="md:absolute md:rotate-90 whitespace-nowrap flex items-baseline gap-2 transition-transform duration-300 group-hover:scale-105">
                        <span className="text-2xl md:text-3xl font-bold font-default text-foreground">
                          {acc.title}
                        </span>
                        <span className="text-sm md:text-base font-semibold text-accent">
                          {acc.subtitle}
                        </span>
                      </div>
                    </div>
                    <ArrowRight className="size-5 text-primary shrink-0 md:mt-auto transition-transform duration-300 group-hover:translate-x-1 md:group-hover:translate-x-0 md:group-hover:translate-y-1" />
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}